"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = percentageLabelFormatter;

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _percentageFormatter = _interopRequireDefault(require("../percentage-formatter"));

function percentageLabelFormatter(value) {
  _argumentContracts.default.assertNumber(value, 'value');

  return "".concat((0, _percentageFormatter.default)(value), "%");
}